import Vue from 'vue';
import VueRouter from 'vue-router';

import Home from '@/components/Home';
import User from '@/components/user/User';
import Welcome from '@/components/Welcome';
import Area from '@/components/Area';
import LogTable from '@/components/Log';
import ActiveCode from '@/pages/ActiveCode';
import Grant from '@/pages/Grant';
import Login from '@/pages/Login';
import NewLogin from '@/pages/NewLogin';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import PrivacyPolicy_DE from '@/pages/PrivacyPolicy_DE'
import PrivacyPolicy_ES from '@/pages/PrivacyPolicy_ES'
import PrivacyPolicy_FR from '@/pages/PrivacyPolicy_FR'
import PrivacyPolicy_IT from '@/pages/PrivacyPolicy_IT'
import PrivacyPolicy_JP from '@/pages/PrivacyPolicy_JP'
import PrivacyPolicy_BR from '@/pages/PrivacyPolicy_BR'
import ResetPassword from '@/pages/ResetPassword';
import UserSignup from '@/pages/UserSignup';
//import Manage from '@/components/Manage';
import AddDevice from '@/components/area/AddDevice';
import Language from '../components/area/Manage.vue';
import DeviceManage from '../components/device/DeviceSessionManage.vue'
import Server from '../components/server/Server.vue'
import About from '../components/about/About.vue'
import Data from '../components/data/Data.vue'
import { getConsoleToken } from '@/utils/storage';

Vue.use(VueRouter)

const publicRoutes = [
    '/active',
    '/grant',
    '/privacy-policy',
    '/privacy-policy-fr',
    '/privacy-policy-de',
    '/privacy-policy-es',
    '/privacy-policy-it',
    '/privacy-policy-jp',
    '/privacy-policy-br',
    '/console/login',
    '/console/login2',
    '/console/reset-password',
    '/console/signup',
    '/console/welcome',
    /*'/console/device',
    '/console/distribute',
    '/console/statistics',
    '/console/info/',
    '/console/users/',
    '/console/user',
    '/console/permissions/',
    '/console/logs/',
    '/console/language',
    '/console/addDevice',
    '/console/device',
    '/console/server',
    '/console/about',
    '/console/data'*/
]

const routesAll = [
    {
        path: '/active',
        component: ActiveCode,
        meta: {title: "Enable Skill"}
    },
    {
        path: '/grant',
        component: Grant,
        meta: {allowBack: false, title: "Enable Skill"}
    },
    {
        path: '/privacy-policy',
        component: PrivacyPolicy,
        meta: {title: "Privacy Policy"}
    },
    {
        path: '/privacy-policy-de',
        component: PrivacyPolicy_DE,
        meta: {title: "Privacy Policy"}
    },
    {
        path: '/privacy-policy-es',
        component: PrivacyPolicy_ES,
        meta: {title: "Privacy Policy"}
    },
    {
        path: '/privacy-policy-fr',
        component: PrivacyPolicy_FR,
        meta: {title: "Privacy Policy"}
    },
    {
        path: '/privacy-policy-it',
        component: PrivacyPolicy_IT,
        meta: {title: "Privacy Policy"}
    },
    {
        path: '/privacy-policy-jp',
        component: PrivacyPolicy_JP,
        meta: {title: "Privacy Policy"}
    },
    {
        path: '/privacy-policy-br',
        component: PrivacyPolicy_BR,
        meta: {title: "Privacy Policy"}
    },
    {
        path: "/console/login",
        component: NewLogin,
        meta: {title: "Login"}
    },
    {
        path: "/console/reset-password",
        component: ResetPassword,
        meta: {title: "ResetPassword"}
    },
    {
        path: "/console/signup",
        component: UserSignup,
        meta: {title: "Signup"}
    },
    {
        path: '/console',
        component: Home,
        children: [
            {
                path: "",
                component: Welcome,
                meta: {title: "TCL Alexa Console"}
            },
            {
                path: "welcome",
                component: Welcome,
                meta: {title: "TCL Alexa Console"}
            },
            {
                path: "area",
                component: Area,
                meta: {title: "TCL Alexa Console"}
            },
            {
                path: "device",
                component: DeviceManage,
                meta: {title: "TCL Alexa Console"}
            },
            {
                path: "addDevice",
                component: AddDevice,
                meta: {title: "TCL Alexa Console"}
            },
            {
                path: "language",
                component: Language,
                meta: {title: "TCL Alexa Console"}
            },
            {
                path: "user",
                component: User,
                meta: {title: "TCL Alexa Console"}
            },
            {
                path: "server",
                component: Server,
                meta: {title: "TCL Alexa Console"}
            },
            {
                path: "log",
                component: LogTable,
                meta: {title: "TCL Alexa Console"}
            },
            {
                path: "data",
                component: Data,
                meta: {title: "TCL Alexa Console"}
            },
            {
                path: "about",
                component: About,
                meta: {title: "TCL Alexa Console"}
            }
        ],
        meta: {title: "Console"}
    },
    {
        path: '/',
        redirect: '/active',
    }
]

const routesPart = [
    {
        path: '/',
        redirect: '/active',
    },
    {
        path: '/active',
        component: ActiveCode,
        meta: {title: "Enable Skill"}
    },
    {
        path: '/grant',
        component: Grant,
        meta: {allowBack: false, title: "Enable Skill"}
    },
    {
        path: '/privacy-policy',
        component: PrivacyPolicy,
        meta: {title: "Privacy Policy"}
    },
]

const routes = process.env.TYPE === "partiall" ? routesPart : routesAll

const router = new VueRouter({
    routes
})


// router.beforeEach((to, from, next) => {
// 	var isLogin = Boolean(store.state.user.token)
// 	if (!isLogin && to.path !== '/login') {
// 	    next({
// 	        path: '/login',
// 	        query: {redirect: to.fullPath}// 将跳转的路由path作为参数，登录成功后跳转到该路由
// 	    })
//     } else {
//       	next()
//     }
// })

router.beforeEach((to, from, next) => {
    let path = to.path
    console.log("==>> beforeEach", path)
    if (getConsoleToken()) {
        console.info("pass")
        next()
    } else if (publicRoutes.find((e) => { return e === path })) {
        console.info("public")
        next()
    } else {
        console.info("redirect")
        next("/console/login")
    }
})

export default router



//////////////////
// WEBPACK FOOTER
// ./src/router/index.js
// module id = null
// module chunks = 